export const defaultEntity = 'users';
export const entities = ['users'];
export const labels = {
    users: 'Accounts',
};